import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { ThemeComponent } from "./theme/theme.component";
import { LayoutModule } from "./theme/layouts/layout.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ScriptLoaderService } from "./_services/script-loader.service";
import { ThemeRoutingModule } from "./theme/theme-routing.module";
import { AuthModule } from "./auth/auth.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CookieService } from "ngx-cookie-service";
// import { NgxEncryptCookieService } from 'ngx-encrypt-cookie'
// import { NgxSecureCookieService } from 'ngx-secure-cookie'
import { HttpClient } from "../ajax/http-client.service";
import { HttpModule } from "@angular/http";
import { ToastrModule } from "ngx-toastr";
import { UiSwitchModule } from "ngx-ui-switch";
import { ResetPasswordModule } from "./components/custompassword/resetpassword.module";
import { RouterModule } from "@angular/router";
import { SharedModule } from "./freightconfirmation/app.sharemodule";
import { CommonComponent } from "./common/common.component";
import { DocumentsharedModule } from "./documentshared/documentshared.module";
import { BookingSharedModule } from "./Bookings/Booking/booking-shared-module.module";
import { BillsSharedModule } from "./Purchase/bills/bills-shared/bills-shared.module";
import { OnflyNetworkModule } from "./Network/onfly-network/onfly-network.module";
import { BookingDashboardModule } from "./Bookings/booking-dashboard/booking-dashboard.module";
import { RouteOptimizationModule } from "./route-optimization/route-optimization.module";
//add kevin 23/11/2020
import { WaypointsMapModule } from "./map/WaypointsMap/Waypoints.module";
import { FuelIssueIndentModule } from "./Bookings/FuelIssueIndent/FuelIssueIndent.module";
//end

import { OnflyDriverModule } from "./Fleet/onfly-driver/onfly-driver.module";
import { NavService } from "../../src/app/_services/NavService.service";
import { AccordionModule } from "primeng/accordion";
import { ProgressBarModule } from "primeng/progressbar";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgCircleProgressModule } from "ng-circle-progress";
import { InputTextareaModule } from "primeng/inputtextarea";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { TimelineService } from "./_services/timeline.service";
import { WebcamModule } from "ngx-webcam";
import { PaymentMadeSharedModule } from "./Purchase/payment-made/payment-made-shared/payment-made-shared.module";
import { PagerService } from "./_services/pagination.service";
import { TransporterService } from "./_services/transporter.service";
// translator Setup
import { TranslateModule } from "@ngx-translate/core";
// import { TranslateHttpLoader } from "@ngx-translate/http-loader";
//import { TranslateConfigService } from './translate-config.service';
// translator setup
import { MapSharedModule } from "./map/map_shared.module";
// import { CustomerDashboardComponent } from './customer-dashboard/customer-dashboard/customer-dashboard.component';

// AoT requires an exported function for factories
// export function createTranslateLoader(http: HttpClient) {
//   return new TranslateHttpLoader(http, "./assets/translator/", ".json");
// }
import { DashboardComponent } from "../app/theme/pages/default/dashboard/dashboard.component";
import { CommonpopModule } from "./Bookings/commonpop/commonpop.module";
// import { CommonpopComponent } from './Bookings/commonpop/commonpop.component';
//add kevin 26/07/2021
import { BidTransporterModule } from "./bid-transporter/bid-transporter.module";
import { LiveTrackingModule } from "./LiveTracking/LiveTracking.module";
import { TrackByNoModule } from "./track-by-no/track-by-no.module";
import { BookDashNewPageRoutingModule } from "./book-dash-new/book-dash-new-routing.module";
//add trupti 03-feb-2022
import { VehiclePlanningService } from "./Quotes/vehicle-plannig.service";
import { ViewInvoiceModule } from "./Sales/view-invoice/view-invoice.module";
import { PickupAssignComponent } from "./pickup-assign/pickup-assign.component";
import { RepairsAndMaintenanceComponent } from "./repairs-and-maintenance/repairs-and-maintenance.component";
import { MainComponent } from "./theme/home/main/main.component";
import { MainSharedModule } from "./theme/home/main/main-shared.module";
import { MainCommonModule } from "./theme/home/main/main-common-module";
import { PrintInvoiceModule } from "./print-invoice/print-invoice.module";
import { HeaderNavSharedModule } from "./theme/layouts/header-nav/header-nav_shared.module";
//import { MainHeaderSharedModule } from "./shared/components/main-header/main-header_shared.module";
import {
  EncryptPipe,
  DecryptPipe,
} from "./auth/_services/encrypt-decrypt.pipe";
import { QRCodeModule } from "angularx-qrcode";
import { taskService } from "./_services/task.service";
import { HttpClientModule } from "@angular/common/http";

import { GlobalErrorHandler } from "./_services/error-handler.service";
import { LiveOrderTrackComponent } from "./Orders/live-order-track/live-order-track.component";
import { EWayBillComponent } from "./Bookings/eway-bill/eway-bill.component";
import { EWayBillModule } from "./Bookings/eway-bill/eway-bill.module";
import { MobileDetectionService } from "./shared/services/mobile-detection.service";
import { NewDesginLayoutSharedModule } from "./shared/components/new-design-layout/new-design-layout-shared.module";
import { BidTransporterPickupRequestComponent } from "./bid-transporter-pickup-request/bid-transporter-pickup-request.component";
import { InternetconnectivityComponent } from "./internetconnectivity/internetconnectivity.component";
import { ModalFormComponent } from './Masters/Products/modal-form/modal-form.component';
import { SsologinComponent } from "./theme/ssologin/ssologin.component";
// import { NewManageCessComponent } from './Accouting/new-manage-cess/new-manage-cess.component';
// import { GeneralLedgerRPComponent } from './Reports/NewAccounts/general-ledger-rp/general-ledger-rp.component';
// import { NewAccountsComponent } from './Reports/NewAccounts/new-accounts/new-accounts.component';
// import { NewMastersComponent } from './Reports/NewMasters/new-masters/new-masters.component';


// import { NewoperationalReportComponent } from './Reports/NewOperations/newoperational-report/newoperational-report.component';






// import { NewDashBoardComponent } from './Fleet/new-dash-board/new-dash-board.component';
// import { MasterRateTemplateProductComponent } from './Masters/master-rate-template-product/master-rate-template-product.component';











//end
//import { VehiclePlanningNewComponent } from './Quotes/vehicle-planning-new/vehicle-planning-new.component';

//end

@NgModule({
  declarations: [
    ThemeComponent,
    AppComponent,
    CommonComponent,
    PickupAssignComponent,
    RepairsAndMaintenanceComponent,
    // VehiclePlanningNewComponent
    EncryptPipe,
    DecryptPipe,
    BidTransporterPickupRequestComponent,
    InternetconnectivityComponent,
    // NewManageCessComponent,
    // GeneralLedgerRPComponent,
    // NewAccountsComponent,
    // NewMastersComponent,
    SsologinComponent




    // NewDashBoardComponent,






















    //VahanComponent,
    //EWayBillComponent,
  ],
  imports: [
    HttpClientModule,
    QRCodeModule,
    WebcamModule,
    InputTextareaModule,
    ScrollPanelModule,
    AccordionModule,
    LayoutModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ThemeRoutingModule,
    AuthModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    TranslateModule.forRoot(),
    ToastrModule.forRoot(),
    UiSwitchModule,
    ResetPasswordModule,
    RouterModule,
    SharedModule,
    DocumentsharedModule,
    BookingSharedModule,
    BillsSharedModule,
    OnflyNetworkModule,
    BookingDashboardModule,
    RouteOptimizationModule,
    //add kevin 23/11/2020
    WaypointsMapModule,
    FuelIssueIndentModule,
    //end
    CommonpopModule,
    OnflyDriverModule,
    ProgressBarModule,
    PaymentMadeSharedModule,
    MapSharedModule,
    HeaderNavSharedModule,
    // MainHeaderSharedModule,
    //pratiksha new design
    NewDesginLayoutSharedModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
    }),
    //add kevin 26/07/2021
    BidTransporterModule,
    LiveTrackingModule,
    TrackByNoModule,
    //end
    ViewInvoiceModule,
    //add vithujan 01-08-2022
    MainCommonModule,
    //end
    //add vithujan 08-08-2022
    PrintInvoiceModule,
    //end
    //add maria
    //EWayBillModule,
    //end
    NgbModule.forRoot(),
    BookDashNewPageRoutingModule,
  ],
  providers: [
    MobileDetectionService,
    ScriptLoaderService,
    CookieService,
    // NgxEncryptCookieService,
    // NgxSecureCookieService,
    HttpClient,
    NavService,
    TimelineService,
    PagerService,
    TransporterService,
    DashboardComponent,
    //add trupti 03-feb-2022
    VehiclePlanningService,
    //end
    EncryptPipe,
    DecryptPipe,
    taskService,

    // { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],

  bootstrap: [AppComponent],
})
export class AppModule { }
